const SharedAudioContext = new window.AudioContext();

export const PlayAudio = async (path: string) => {
  SharedAudioContext.resume()
    .then(async () => {
      const response = await fetch(path);
      const arrayBuffer = await response.arrayBuffer();

      const audioBuffer = await SharedAudioContext.decodeAudioData(arrayBuffer);

      const source = SharedAudioContext.createBufferSource();
      source.buffer = audioBuffer;

      source.connect(SharedAudioContext.destination);

      source.start(0);
    })
    .catch((e) => {
      console.error("Failed to resume audio context:", e);
    });
};
